import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import _ from 'lodash';
import moment from "moment";
import FluxoSubstituicaoStore from "./FluxoSubstituicaoStore";
import {motivoContratacaoEnum} from "../../../../utils/enums";

export default class AndamentoSubstituicaoStore extends FluxoSubstituicaoStore {


    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);
    }

    getSolicitacao(dadosUrl) {
        const substituicaoId = parseInt(dadosUrl.substituicaoId.replace("SB", ""));


        this.nomeFluxo = "GloboMOTSubstituicao";
        this.nomeTarefa = "HT_AvaliarSolicitacaoGestor";

        this.loadingPanelStore.setIsLoading("AndamentoSubstituicaoLoading", true);


        let promise = this.solicitacaoService.carregarDetalhesSolicitacaoBySubstituicaoId(substituicaoId);

        promise.then(response => {

            this.handleSolicitacaoPorId(response.data.solicitacao, !!dadosUrl.solicitacaoEttId, false);
            this.handleSolicitacaoEttById(response.data.solicitacaoEtt, false);
            this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);

            this.carregarDadosProrrogacoesAnteriores();
            this.carregarDadosExtras(response.data, "andamentoSubstituicao", dadosUrl);

            this.loadingPanelStore.setIsLoading("AndamentoSubstituicaoLoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("AndamentoSubstituicaoLoading", false);
        });
    }
}